import ChatBoard from "../messenger/chat";

const ChatBox = () => {
  return <ChatBoard />
}

export default ChatBox;
